import {CgWebsite} from "react-icons/cg";
import {PiUserSquareFill} from "react-icons/pi";
import {useContext, useEffect, useState} from "react";
import SetItemsContext from "../../tools/contexts/authenticatonService/SetItemsContext";
import BottomButtonWrapper from "../BottomButtonWrapper";
import Button from "../Button";

import DiscountCard, {ActiveDiscountCard} from "./DiscountCard";
import preConfirmDiscount from "../../tools/api/authentication/preConfirmDiscount";
import AuthenticationServiceContext from "../../tools/contexts/authenticatonService/AuthenticationServiceContext";
import removeDiscount from "../../tools/api/authentication/removeDiscount";
import LoadingScreen from "../LoadingScreen";


const defaults = {
    "IAuth": [

        {
            icon: <CgWebsite className="text-gray-500 text-5xl "/>,
            title: 'افزودن روی این آگهی',
            description: <p className="text-gray-700 text-sm">با انتخاب این گزینه، افزونه تنها بر روی این آگهی قرار
                خواهد
                گرفت.</p>,
            type: 'post',

        },
        {
            icon: <PiUserSquareFill className="text-gray-500 text-5xl "/>,
            title: 'افزودن روی حساب کاربری',
            description: <p className="text-gray-700 h-auto text-sm">افزونه بر روی <strong>تمامی آگهی‌های</strong> شما
                به مدت سه ماه اضافه
                خواهد شد و هر آگهی جدیدی که ثبت کنید این افزونه بر روی آن نیز قرار خواهد گرفت.</p>,
            type: 'add_on',

        }
    ],
    "PoliceClearance": [

        {
            icon: <CgWebsite className="text-gray-500 text-5xl "/>,
            title: 'افزودن روی این آگهی',
            description: <p className="text-gray-700 text-sm">با انتخاب این گزینه، افزونه تنها بر روی این آگهی قرار
                خواهد
                گرفت.</p>,
            type: 'post',

        },
        {
            icon: <PiUserSquareFill className="text-gray-500 text-5xl "/>,
            title: 'افزودن روی حساب کاربری',
            description: <p className="text-gray-700 h-auto text-sm">افزونه بر روی <strong>تمامی آگهی‌های</strong> شما
                به مدت سه ماه اضافه
                خواهد شد و هر آگهی جدیدی که ثبت کنید این افزونه بر روی آن نیز قرار خواهد گرفت.</p>,
            type: 'add_on',

        }
    ],
    "BusinessLicenseInquiry": [

        {
            icon: <CgWebsite className="text-gray-500 text-5xl "/>,
            title: 'افزودن روی این آگهی',
            description: <p className="text-gray-700 text-sm">با انتخاب این گزینه، افزونه تنها بر روی این آگهی قرار
                خواهد
                گرفت.</p>,
            type: 'post',

        },
        {
            icon: <PiUserSquareFill className="text-gray-500 text-5xl "/>,
            title: 'افزودن روی حساب کاربری',
            description: <p className="text-gray-700 h-auto text-sm">افزونه بر روی <strong>تمامی آگهی‌های</strong> شما
                به مدت سه ماه اضافه
                خواهد شد و هر آگهی جدیدی که ثبت کنید این افزونه بر روی آن نیز قرار خواهد گرفت.</p>,
            type: 'add_on',

        }
    ]
};
const AccessCard = ({data}) => {
    const formattedPrice = new Intl.NumberFormat('fa-IR');
    const {type, title, description, icon} = data;
    const setItemsContext = useContext(SetItemsContext);

    const [price, setPrice] = useState(0);
    const [payablePrice, setPayablePrice] = useState(0);
    const [discountPercent, setDiscountPercent] = useState(0);
    const [priceWithDiscount, setPriceWithDiscount] = useState(0);
    const [hasDiscount, setHasDiscount] = useState(false);
    const defaultServiceItemList = setItemsContext.data && setItemsContext?.data?.items ? setItemsContext.data.items.filter(item => setItemsContext.data.default_service === item.service_type) : null;
    const defaultServiceItem = defaultServiceItemList.length > 0 ? defaultServiceItemList[0] : null
    const priceCalculator = () => {
        let p = 0;
        let pPayable = 0;
        let pWithDiscount = 0;

        if (setItemsContext?.data.discount) {

            if (data.type === "post") {
                const discount = setItemsContext?.data?.discount.props[setItemsContext?.defaultService.service_type].post_add_on;
                setDiscountPercent(discount);
                if (discount > 0) {
                    setHasDiscount(true);
                } else {
                    setHasDiscount(false);
                }
            } else {
                const discount = setItemsContext?.data?.discount.props[setItemsContext?.defaultService.service_type].user_add_on;
                setDiscountPercent(discount)
                if (discount > 0) {
                    setHasDiscount(true);
                } else {
                    setHasDiscount(false);
                }
            }
        } else {
            setHasDiscount(false);
        }
        if (setItemsContext.requiredServices) {
            setItemsContext.requiredServices.map((requiredService) => {

                if (setItemsContext.requiredServices.length > 1) {
                    if (data.type === "post") {
                        if (setItemsContext?.data.discount) {
                            pWithDiscount = pWithDiscount + requiredService.prices.second.price - (requiredService.prices.second.price * setItemsContext?.data?.discount.props[requiredService.service_type].post_add_on / 100)
                        }

                        p = p + requiredService.prices.main.price;
                        pPayable = pPayable + requiredService.prices.second.price;
                    } else {
                        if (setItemsContext?.data.discount) {
                            pWithDiscount = pWithDiscount + requiredService.prices.user_add_on_second.price - (requiredService.prices.user_add_on_second.price * setItemsContext?.data?.discount.props[requiredService.service_type].user_add_on / 100)
                        }
                        p = p + requiredService.prices.user_add_on.price;
                        pPayable = pPayable + requiredService.prices.user_add_on_second.price;
                    }

                } else {
                    if (data.type === "post") {
                        if (setItemsContext?.data.discount) {
                            pWithDiscount = pWithDiscount + requiredService.prices.main.price - (requiredService.prices.main.price * setItemsContext?.data?.discount.props[requiredService.service_type].post_add_on / 100)
                        }

                        p = p + requiredService.prices.main.price;
                        pPayable = pPayable + requiredService.prices.main.price;
                    } else {
                        if (setItemsContext?.data.discount) {
                            pWithDiscount = pWithDiscount + requiredService.prices.user_add_on.price - (requiredService.prices.user_add_on.price * setItemsContext?.data?.discount.props[requiredService.service_type].user_add_on / 100)
                        }

                        p = p + requiredService.prices.user_add_on.price;
                        pPayable = pPayable + requiredService.prices.user_add_on.price;
                    }
                }

            });
            setPrice(p);
            setPayablePrice(pPayable);
            setPriceWithDiscount(pWithDiscount);

        }
    }

    useEffect(() => {
        if (defaultServiceItem) {
            priceCalculator();
        }

    }, [])
    const handleSelectItem = () => {
        setItemsContext.handleSelectedType(type)
    }
    return <div onClick={handleSelectItem}
                className={`addon-card ${type === setItemsContext.selectedType ? 'active' : ''}`}>
        {discountPercent > 0 && <small className="discount">{`${discountPercent}% تخفیف`}</small>}
        <div className="content">
            <h1 className="font-bold   mb-1  ">{title}</h1>
            <div className="text-sm text-wrap mb-1 text-gray-700">{description}</div>
            <div className="pt-2 w-full  mt-2 border-t">
                {hasDiscount && <div className="w-full flex justify-between items-center">
                    {setItemsContext.requiredServices && setItemsContext.requiredServices.length > 1 && <>
                        <span
                            className="line-through text-sm text-red-500">{`${formattedPrice.format(payablePrice / 10)} تومان `}</span>
                        <span
                            className="font-semibold text-green-500">{discountPercent === 100 ? "رایگان" : `${formattedPrice.format(priceWithDiscount / 10)} تومان`}</span>

                    </>}
                    {setItemsContext.requiredServices && setItemsContext.requiredServices.length === 1 && <>
                        <span
                            className="line-through text-sm text-red-500">{`${formattedPrice.format(price / 10)} تومان `}</span>
                        <span
                            className="font-semibold text-green-500">{discountPercent === 100 ? "رایگان" : `${formattedPrice.format(priceWithDiscount / 10)} تومان`}</span>

                    </>}
                </div>
                }
                {!hasDiscount && <div className="justify-between flex items-center ">
                    {setItemsContext.requiredServices && setItemsContext.requiredServices.length > 1 && <>
                        <span
                            className="line-through text-sm text-red-500">{`${formattedPrice.format(price / 10)} تومان `}</span>
                        <span className="text-green-500  font-semibold ">{formattedPrice.format(payablePrice / 10)}
                            <span className="mr-1">تومان</span></span>

                    </>}
                    {setItemsContext.requiredServices && setItemsContext.requiredServices.length === 1 && <>
                        <div/>
                        <span className=" text-green-500 font-semibold">{formattedPrice.format(price / 10)} <small
                            className="mr-1">تومان</small></span>


                    </>}
                </div>
                }

            </div>
        </div>

    </div>
}
const NewAddon = () => {

    const setItemsContext = useContext(SetItemsContext);
    const serviceContext = useContext(AuthenticationServiceContext)
    const [discountError, setDiscountError] = useState(null);
    const [removeDiscountError, setRemoveDiscountError] = useState(null);
    const [loading, setLoading] = useState(false);
    const [title, setTitle] = useState(null);
    const [discountPreLoading, setDiscountPreLoading] = useState(true)
    useEffect(() => {
        if (setItemsContext?.data?.default_service) {
            handleTitle(setItemsContext?.data?.default_service)
        }
    }, [setItemsContext])
    useEffect(async () => {
        if (localStorage.getItem('discount_code')) {
            const params = {
                pid: serviceContext.pid,
                code: localStorage.getItem('discount_code'),
            }
            const response = await preConfirmDiscount(serviceContext.token, params);
            const {hasError} = response;
            setDiscountPreLoading(false);
            localStorage.removeItem('discount_code')
            if (!hasError) {
                setItemsContext.handleGetItems();
            }
        } else {
            setDiscountPreLoading(false)
        }
    }, []);
    const handleSubmit = () => {
        setItemsContext.handleStep(2)
    }
    const handleDiscount = async (code) => {
        setLoading(true);
        const params = {
            pid: serviceContext.pid,
            code,
        }
        const response = await preConfirmDiscount(serviceContext.token, params);
        const {hasError, message} = response;
        setLoading(false);
        if (!hasError) {
            setItemsContext.handleGetItems();
        } else {
            setDiscountError(message)
        }
    }
    const handleTitle = (defaultService) => {
        if (defaultService === "PoliceClearance") {
            setTitle("تایید عدم سوء پیشینه و احراز هویت ")
        } else if (defaultService === "IAuth") {
            setTitle("احراز هویت ونیفای")
        } else if (defaultService === "BusinessLicenseInquiry") {
            setTitle("استعلام مجوز کسب و کار")
        }
    }
    const handleRemoveDiscount = async () => {
        const params = {
            pid: serviceContext.pid,
        }
        setLoading(true);
        const response = await removeDiscount(serviceContext.token, params);
        const {hasError, message} = response;
        setLoading(false);

        if (!hasError) {
            setItemsContext.handleGetItems();

        } else {
            setRemoveDiscountError(message);
        }
    }
    if (discountPreLoading) {
        return <LoadingScreen/>
    }
    return <div className="w-full">
        <h1 className="text-xl text-center mt-6 mb-5 font-bold">
            {title}
        </h1>
        <div className="w-11/12 flex mx-auto  mt-2 flex-col items-center justify-center 2xl:w-4/12 lg:w-6/12">
            {setItemsContext?.data?.default_service && defaults[setItemsContext?.data?.default_service].filter((value)=>{
                if(value.type==="post"){
                    return true
                }else {
                  return  setItemsContext.addonIsActive
                }

            }).map(item => {
                return <AccessCard data={item} key={item.type}/>
            })}
            <div className="mb-20 w-full ">
                {setItemsContext?.data?.discount &&
                    <ActiveDiscountCard error={removeDiscountError} loading={loading} canDelete={true}
                                        onDelete={handleRemoveDiscount}
                                        code={setItemsContext.data.discount?.code}/>}
                {!setItemsContext?.data?.discount &&
                    <DiscountCard loading={loading} errorMessage={discountError} onConfirm={handleDiscount}/>}
            </div>

        </div>
        <BottomButtonWrapper>
            <Button theme="green" onClick={handleSubmit} rounded="rounded-lg" className="text-sm">شروع</Button>
        </BottomButtonWrapper>
    </div>
}
export default NewAddon;